import type { ClientProjectActivity } from '@packages/types';

/**
 * True when an activity was logged from a calendar event and the reference to
 * the stored calendar event is still present. The processor sets `source` to
 * `'CALENDAR'` and `sourceRef` to the stored calendar event id when it
 * auto-creates a draft from a calendar match (createActivityFromCalendarMatch
 * in client-project-activity.service.ts). Manual matches still go through the
 * same code path, so they too land here.
 *
 * A missing sourceRef is treated as "no calendar event to preview" - legacy
 * rows predate the sourceRef column and must not render a half-state preview.
 */
export function hasSourceCalendar(
  activity: Pick<ClientProjectActivity, 'source' | 'sourceRef'>,
): activity is typeof activity & { sourceRef: string } {
  return activity.source === 'CALENDAR' && !!activity.sourceRef;
}
